import { useEffect } from "react";

export const useOutsideClick = (ref, callback) => {
  useEffect(() => {
    const listener = (event) => {
      // Si no hay referencia o el clic está dentro del elemento referenciado, no hacer nada
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      // Si el clic está fuera del elemento, ejecutar la callback
      callback(event);
    };

    // Añadir los event listeners para "mousedown" y "touchstart"
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    // Limpiar los event listeners cuando el componente se desmonte
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, callback]); // Ejecutar useEffect cuando cambie ref o callback
};
